import fetch from 'isomorphic-fetch';
import {commonHeaders} from './fetch.util';

export const SYSTEM_MAINTENANCE_NOTICE_REQUEST = 'SYSTEM_MAINTENANCE_NOTICE_REQUEST';
export const SYSTEM_MAINTENANCE_NOTICE_RESPONSE = 'SYSTEM_MAINTENANCE_NOTICE_RESPONSE';

function systemMaintenanceNoticeRequest() {
  return {
    type: SYSTEM_MAINTENANCE_NOTICE_REQUEST,
  };
}

function systemMaintenanceNoticeResponse(systemMaintenanceNotice) {
  return {
    type: SYSTEM_MAINTENANCE_NOTICE_RESPONSE,
    systemMaintenanceNotice,
  };
}

export function fetchSystemMaintenanceNotice() {
  return dispatch => {
    dispatch(systemMaintenanceNoticeRequest());

    fetch(`${API_URL}/system-maintenance-notices/currently-enabled`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => response.json())
      .then(systemMaintenanceNotice => {
        dispatch(systemMaintenanceNoticeResponse(systemMaintenanceNotice));
      })
      .catch(() => alert('점검 상세 요청에 실패했습니다.'));
  };
}
